import Body from "./Body"
import Dialog from "./Dialog"
import Footer from "./Footer"
import Header from "./Header"

export default { Body, Dialog, Footer, Header }
